(() => {
  if (window.__snugAdvancedCollectionLoaded) return;
  window.__snugAdvancedCollectionLoaded = true;

  const filterParams = () => [...new URLSearchParams(location.search).keys()].filter((key) => key.startsWith('filter.'));

  function buildSortUrl(sortBy) {
    const url = new URL(location.href);
    if (sortBy) url.searchParams.set('sort_by', sortBy);
    else url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    return `${url.pathname}${url.search}`;
  }

  function enhance(section) {
    if (!section || section.dataset.snugCollectionEnhanced === 'true') return;
    section.dataset.snugCollectionEnhanced = 'true';
    document.body.classList.add('snug-collection-enhanced');

    const sidebar = section.querySelector('#CollectionSidebar .collection-sidebar');
    if (sidebar && !sidebar.querySelector('.snug-filter-intro')) {
      sidebar.insertAdjacentHTML('afterbegin', `
        <div class="snug-filter-intro">
          <span class="snug-filter-intro__eyebrow">Refine your results</span>
          <strong>Find the right sofa cover</strong>
          <p>Filter by availability, category and price, then confirm colour and measurements on the product page.</p>
        </div>`);
    }

    const toolbar = section.querySelector('.toolbar.toolbar-products');
    if (toolbar && !toolbar.previousElementSibling?.classList.contains('snug-collection-tools')) {
      const activeCount = filterParams().length;
      const tools = document.createElement('div');
      tools.className = 'snug-collection-tools';
      tools.innerHTML = `
        <div class="snug-collection-tools__copy">
          <span class="snug-collection-tools__eyebrow">Shop smarter</span>
          <strong>Choose your best match</strong>
          <span>Free Australia-wide delivery</span>
        </div>
        <nav class="snug-quick-sort" aria-label="Quick product sorting">
          <a href="${buildSortUrl('best-selling')}" data-sort-value="best-selling">Best sellers</a>
          <a href="${buildSortUrl('price-ascending')}" data-sort-value="price-ascending">Lowest price</a>
          <a href="${buildSortUrl('created-descending')}" data-sort-value="created-descending">Newest</a>
        </nav>`;
      toolbar.before(tools);

      const currentSort = new URLSearchParams(location.search).get('sort_by') || 'manual';
      tools.querySelectorAll('[data-sort-value]').forEach((link) => {
        const selected = link.dataset.sortValue === currentSort;
        link.classList.toggle('is-selected', selected);
        if (selected) link.setAttribute('aria-current', 'page');
      });

      const filterButton = toolbar.querySelector('btn-filter');
      if (filterButton) {
        filterButton.setAttribute('role', 'button');
        filterButton.setAttribute('tabindex', '0');
        filterButton.setAttribute('aria-label', activeCount ? `Open filters, ${activeCount} active` : 'Open product filters');
        if (activeCount) {
          filterButton.insertAdjacentHTML('beforeend', `<span class="snug-filter-count" aria-hidden="true">${activeCount}</span>`);
        }
        filterButton.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            filterButton.click();
          }
        });
      }
    }

    section.querySelectorAll('filter-item').forEach((item) => {
      item.setAttribute('role', 'checkbox');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-checked', String(item.classList.contains('active')));
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          item.click();
        }
      });
    });

    section.querySelectorAll('.filter-item collapsible-block').forEach((block) => {
      const heading = block.querySelector(':scope > .collapsible-heading');
      if (!heading) return;
      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');
      heading.setAttribute('aria-expanded', String(block.classList.contains('active')));
      heading.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          heading.click();
        }
      });
    });

    const amount = section.querySelector('#toolbar-amount');
    if (amount) {
      const count = amount.textContent.match(/[\d,]+/)?.[0];
      if (count) amount.innerHTML = `<strong>${count}</strong><span> sofa covers found</span>`;
    }
  }

  function enhanceAll() {
    document.querySelectorAll('.sec__collection-main').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll, { once: true });
  } else {
    enhanceAll();
  }

  document.addEventListener('shopify:section:load', enhanceAll);

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => [...mutation.addedNodes].some((node) => node.nodeType === 1 && (node.matches?.('.sec__collection-main') || node.querySelector?.('.sec__collection-main'))))) {
      enhanceAll();
    }
  });
  const observerRoot = document.getElementById('MainContent') || document.body;
  observer.observe(observerRoot, { childList: true, subtree: true });
})();
